/* eslint-disable import/prefer-default-export */
export function isoTimeFormatter(timestamp) {
  return new Date(timestamp).toISOString();
}